import { render, staticRenderFns } from "./TransfersArchiveForm.vue?vue&type=template&id=246f6924&scoped=true"
import script from "./TransfersArchiveForm.vue?vue&type=script&lang=js"
export * from "./TransfersArchiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f6924",
  null
  
)

export default component.exports